import { gql, MutationHookOptions, TypedDocumentNode, useMutation } from "@apollo/client";

import {
  UpdateScenarioDraftVersionMutation,
  UpdateScenarioDraftVersionMutationVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { scenarioVersionWithRulesFragment } from "src/graphql/anti-fraud/fragments/ScenarioVersionFragment";

export const updateScenarioDraftVersionMutation = gql`
  mutation updateScenarioDraftVersion($id: ID!, $options: UpdateDraftVersionOptions!) {
    updateDraftVersion(options: $options, id: $id) {
      ...ScenarioVersionWithRulesFragment
    }
  }

  ${scenarioVersionWithRulesFragment}
` as TypedDocumentNode<
  UpdateScenarioDraftVersionMutation,
  UpdateScenarioDraftVersionMutationVariables
>;

export const useUpdateScenarioDraftVersionMutation = (
  options?: MutationHookOptions<
    UpdateScenarioDraftVersionMutation,
    UpdateScenarioDraftVersionMutationVariables
  >
) => {
  return useMutation(updateScenarioDraftVersionMutation, options);
};
